/**
 * Serviço de Contas Meta
 * Responsabilidade: Gerenciar contas de anúncios do Meta (Facebook/Instagram)
 */

import { supabase } from '../../lib/supabase';
import { MetaAccount } from '../../types';
import { mapMetaAccountFromDB } from '../mappers/entityMappers';

/**
 * Busca todas as contas Meta conectadas
 */
export const getMetaAccounts = async (): Promise<MetaAccount[]> => {
    try {
        const { data, error } = await supabase
            .from('integrations')
            .select('*')
            .eq('type', 'meta_ads');

        if (error) throw error;

        return (data || []).map(mapMetaAccountFromDB);
    } catch (error) {
        console.error('Error fetching meta accounts:', error);
        return [];
    }
};
